<template>
  <div class="main-wrapper">
    <slot />
  </div>
</template>

<style>
	body {
		color: #000
	}

	section {
		padding: 120px 0;
	}
	article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
		display: block;
	}

	.support-us .container, .section-design-right, .section-design {
		position: relative;
	}
	.support-us .container:after, .section-design-right:after, .section-design:after, .hero:after {
		content: ' ';
		background-image: linear-gradient(to bottom, #697ded, #5e30c1);
		position: absolute;
		border-radius: 50% 0 0 50%;
		top: -180px;
		right: 0;
		bottom: -50px;
		width: 53%;
		transform: skewY(-20deg);
		z-index: -1;
	}

	.section-design-right:after, .section-design:after {
		right: 20px;
		top: 0;
		bottom: 0;
		left: 40px;
		border-radius: 20% 50% 50% 30%;
		transform: skewY(20deg) skewX(-22deg);
		width: 36%;
	}
	section p, section ul, section ol {
		color: #4e5051;
	}
</style>

<script>
import NProgress from 'nprogress'

export default {
	data(){
		return {
			
		}
	},
	mounted(){
		NProgress.start()
		setTimeout(() => NProgress.done(), 500)

	}
}
</script>